import React from 'react'
import { NavBarWrapper } from './Styles'
import LogOut from 'react-feather/dist/icons/log-out'
import Button from '../Button/Button'

const localStorage = window.localStorage

const NavBar = (props) => {
  return (
    <NavBarWrapper>
      {
        localStorage.getItem('uid') && <Button icon onClick={() => localStorage.removeItem('uid')}>
          <LogOut />
        </Button>
      }
    </NavBarWrapper>
  )
}

export default NavBar



// WEBPACK FOOTER //
// ./src/Components/NavBar/NavBar.jsx